import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://www.linkedin.com/in/shematsic/"
          target="_blank"
          rel="noopener noreferrer"
        >
          SHILOH FARM
        </a>
      </header>
    </div>
  );
}

export default App;
